import type { LoggerOptions } from 'pino';

type LoggerPrettyOptions = {
  transport: LoggerOptions['transport'];
};

export const getPinoPrettyOptions = (): LoggerPrettyOptions | undefined => {
  const isServerSide = typeof process === 'object';

  if (!isServerSide) {
    return undefined;
  }

  const isProduction = process.env.NODE_ENV === 'production';

  const defaultKeysToIgnore = [
    'application',
    'opVersion',
    'severity',
    'sensitivity',
    'message.text',
    'type',
    'requestId',
    'thread',
    'environment',
    'timestamp',
    'component',
    'logger',
    'hostname',
    'pid',
    'message.remoteAddress',
    'message.requestStartTime',
    'message.responseTimeMs',
    'message.totalRequestTimeMs',
    'message.responseContentLengthBytes',
    'message.requestContentLengthBytes',
    'message.userAgent',
    'message.httpVersion',
  ];
  /**
   * Pretty print is implemented using 'pino-pretty' and it is intended
   * to be used in development only. Do not use it inside production, because
   * 'pino-pretty' is devDependency.
   */
  if (!isProduction && process.env.LOGGER_PRETTY) {
    const messageFormat = process.env.LOGGER_PRETTY_MSG_FORMAT || '[{severity}] {timestamp} - {message.text}';
    const ignore = process.env.LOGGER_PRETTY_IGNORE || defaultKeysToIgnore.join(',');
    const prettyOptions = {
      transport: {
        target: 'pino-pretty',
        options: {
          singleLine: true,
          colorize: true,
          messageFormat,
          ignore,
        },
      },
    } satisfies LoggerPrettyOptions;

    return prettyOptions;
  }

  return undefined;
};
